module.exports = __webpack_public_path__ + "static/media/3-foundations-saturation.c714b5ea.jpg";